import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const NotificationsSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default NotificationsSVG;
